<template>
  <div class="loader">
    <div class="content">
      <div class="icon"><div class="loader"></div></div>
      <div class="text">{{t('loading_indicator')}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Loader",
    
  }
</script>

<style lang="stylus" scoped>
.loader
  position absolute
  top 0
  left 0
  width 100%
  height 100%
  // background rgba(0,0,0,0.2)
  background rgba(240,240,240,0.8)
  z-index 3
  .content
    position absolute
    display: flex;
    flex-direction: column;
    align-items: center;
    top 40%
    left 50%
    transform translate(-50%,-50%)
    // .icon
    //   width: 30px
    //   height : 30px
    //   background: #444
      
    .text
      margin-top 30px
      text-align center
      font-family 'Lato'
      
.icon
  height 60px
  width 60px

  .loader {
  margin: 50% auto;
  font-size: 12px;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  -webkit-animation: load5 1.1s infinite ease;
  animation: load5 1.1s infinite ease;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
@-webkit-keyframes load5 {
  0%,
  100% {
    box-shadow: 0em -2.6em 0em 0em #666666, 1.8em -1.8em 0 0em rgba(102,102,102, 0.2), 2.5em 0em 0 0em rgba(102,102,102, 0.2), 1.75em 1.75em 0 0em rgba(102,102,102, 0.2), 0em 2.5em 0 0em rgba(102,102,102, 0.2), -1.8em 1.8em 0 0em rgba(102,102,102, 0.2), -2.6em 0em 0 0em rgba(102,102,102, 0.5), -1.8em -1.8em 0 0em rgba(102,102,102, 0.7);
  }
  12.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(102,102,102, 0.7), 1.8em -1.8em 0 0em #666666, 2.5em 0em 0 0em rgba(102,102,102, 0.2), 1.75em 1.75em 0 0em rgba(102,102,102, 0.2), 0em 2.5em 0 0em rgba(102,102,102, 0.2), -1.8em 1.8em 0 0em rgba(102,102,102, 0.2), -2.6em 0em 0 0em rgba(102,102,102, 0.2), -1.8em -1.8em 0 0em rgba(102,102,102, 0.5);
  }
  25% {
    box-shadow: 0em -2.6em 0em 0em rgba(102,102,102, 0.5), 1.8em -1.8em 0 0em rgba(102,102,102, 0.7), 2.5em 0em 0 0em #666666, 1.75em 1.75em 0 0em rgba(102,102,102, 0.2), 0em 2.5em 0 0em rgba(102,102,102, 0.2), -1.8em 1.8em 0 0em rgba(102,102,102, 0.2), -2.6em 0em 0 0em rgba(102,102,102, 0.2), -1.8em -1.8em 0 0em rgba(102,102,102, 0.2);
  }
  37.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(102,102,102, 0.2), 1.8em -1.8em 0 0em rgba(102,102,102, 0.5), 2.5em 0em 0 0em rgba(102,102,102, 0.7), 1.75em 1.75em 0 0em #666666, 0em 2.5em 0 0em rgba(102,102,102, 0.2), -1.8em 1.8em 0 0em rgba(102,102,102, 0.2), -2.6em 0em 0 0em rgba(102,102,102, 0.2), -1.8em -1.8em 0 0em rgba(102,102,102, 0.2);
  }
  50% {
    box-shadow: 0em -2.6em 0em 0em rgba(102,102,102, 0.2), 1.8em -1.8em 0 0em rgba(102,102,102, 0.2), 2.5em 0em 0 0em rgba(102,102,102, 0.5), 1.75em 1.75em 0 0em rgba(102,102,102, 0.7), 0em 2.5em 0 0em #666666, -1.8em 1.8em 0 0em rgba(102,102,102, 0.2), -2.6em 0em 0 0em rgba(102,102,102, 0.2), -1.8em -1.8em 0 0em rgba(102,102,102, 0.2);
  }
  62.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(102,102,102, 0.2), 1.8em -1.8em 0 0em rgba(102,102,102, 0.2), 2.5em 0em 0 0em rgba(102,102,102, 0.2), 1.75em 1.75em 0 0em rgba(102,102,102, 0.5), 0em 2.5em 0 0em rgba(102,102,102, 0.7), -1.8em 1.8em 0 0em #666666, -2.6em 0em 0 0em rgba(102,102,102, 0.2), -1.8em -1.8em 0 0em rgba(102,102,102, 0.2);
  }
  75% {
    box-shadow: 0em -2.6em 0em 0em rgba(102,102,102, 0.2), 1.8em -1.8em 0 0em rgba(102,102,102, 0.2), 2.5em 0em 0 0em rgba(102,102,102, 0.2), 1.75em 1.75em 0 0em rgba(102,102,102, 0.2), 0em 2.5em 0 0em rgba(102,102,102, 0.5), -1.8em 1.8em 0 0em rgba(102,102,102, 0.7), -2.6em 0em 0 0em #666666, -1.8em -1.8em 0 0em rgba(102,102,102, 0.2);
  }
  87.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(102,102,102, 0.2), 1.8em -1.8em 0 0em rgba(102,102,102, 0.2), 2.5em 0em 0 0em rgba(102,102,102, 0.2), 1.75em 1.75em 0 0em rgba(102,102,102, 0.2), 0em 2.5em 0 0em rgba(102,102,102, 0.2), -1.8em 1.8em 0 0em rgba(102,102,102, 0.5), -2.6em 0em 0 0em rgba(102,102,102, 0.7), -1.8em -1.8em 0 0em #666666;
  }
}
@keyframes load5 {
  0%,
  100% {
    box-shadow: 0em -2.6em 0em 0em #666666, 1.8em -1.8em 0 0em rgba(102,102,102, 0.2), 2.5em 0em 0 0em rgba(102,102,102, 0.2), 1.75em 1.75em 0 0em rgba(102,102,102, 0.2), 0em 2.5em 0 0em rgba(102,102,102, 0.2), -1.8em 1.8em 0 0em rgba(102,102,102, 0.2), -2.6em 0em 0 0em rgba(102,102,102, 0.5), -1.8em -1.8em 0 0em rgba(102,102,102, 0.7);
  }
  12.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(102,102,102, 0.7), 1.8em -1.8em 0 0em #666666, 2.5em 0em 0 0em rgba(102,102,102, 0.2), 1.75em 1.75em 0 0em rgba(102,102,102, 0.2), 0em 2.5em 0 0em rgba(102,102,102, 0.2), -1.8em 1.8em 0 0em rgba(102,102,102, 0.2), -2.6em 0em 0 0em rgba(102,102,102, 0.2), -1.8em -1.8em 0 0em rgba(102,102,102, 0.5);
  }
  25% {
    box-shadow: 0em -2.6em 0em 0em rgba(102,102,102, 0.5), 1.8em -1.8em 0 0em rgba(102,102,102, 0.7), 2.5em 0em 0 0em #666666, 1.75em 1.75em 0 0em rgba(102,102,102, 0.2), 0em 2.5em 0 0em rgba(102,102,102, 0.2), -1.8em 1.8em 0 0em rgba(102,102,102, 0.2), -2.6em 0em 0 0em rgba(102,102,102, 0.2), -1.8em -1.8em 0 0em rgba(102,102,102, 0.2);
  }
  37.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(102,102,102, 0.2), 1.8em -1.8em 0 0em rgba(102,102,102, 0.5), 2.5em 0em 0 0em rgba(102,102,102, 0.7), 1.75em 1.75em 0 0em #666666, 0em 2.5em 0 0em rgba(102,102,102, 0.2), -1.8em 1.8em 0 0em rgba(102,102,102, 0.2), -2.6em 0em 0 0em rgba(102,102,102, 0.2), -1.8em -1.8em 0 0em rgba(102,102,102, 0.2);
  }
  50% {
    box-shadow: 0em -2.6em 0em 0em rgba(102,102,102, 0.2), 1.8em -1.8em 0 0em rgba(102,102,102, 0.2), 2.5em 0em 0 0em rgba(102,102,102, 0.5), 1.75em 1.75em 0 0em rgba(102,102,102, 0.7), 0em 2.5em 0 0em #666666, -1.8em 1.8em 0 0em rgba(102,102,102, 0.2), -2.6em 0em 0 0em rgba(102,102,102, 0.2), -1.8em -1.8em 0 0em rgba(102,102,102, 0.2);
  }
  62.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(102,102,102, 0.2), 1.8em -1.8em 0 0em rgba(102,102,102, 0.2), 2.5em 0em 0 0em rgba(102,102,102, 0.2), 1.75em 1.75em 0 0em rgba(102,102,102, 0.5), 0em 2.5em 0 0em rgba(102,102,102, 0.7), -1.8em 1.8em 0 0em #666666, -2.6em 0em 0 0em rgba(102,102,102, 0.2), -1.8em -1.8em 0 0em rgba(102,102,102, 0.2);
  }
  75% {
    box-shadow: 0em -2.6em 0em 0em rgba(102,102,102, 0.2), 1.8em -1.8em 0 0em rgba(102,102,102, 0.2), 2.5em 0em 0 0em rgba(102,102,102, 0.2), 1.75em 1.75em 0 0em rgba(102,102,102, 0.2), 0em 2.5em 0 0em rgba(102,102,102, 0.5), -1.8em 1.8em 0 0em rgba(102,102,102, 0.7), -2.6em 0em 0 0em #666666, -1.8em -1.8em 0 0em rgba(102,102,102, 0.2);
  }
  87.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(102,102,102, 0.2), 1.8em -1.8em 0 0em rgba(102,102,102, 0.2), 2.5em 0em 0 0em rgba(102,102,102, 0.2), 1.75em 1.75em 0 0em rgba(102,102,102, 0.2), 0em 2.5em 0 0em rgba(102,102,102, 0.2), -1.8em 1.8em 0 0em rgba(102,102,102, 0.5), -2.6em 0em 0 0em rgba(102,102,102, 0.7), -1.8em -1.8em 0 0em #666666;
  }
}



</style>